import { DataQuery } from '../utils/DataQuery';
import { DataRecord } from '../utils/DataRecord';

import { LogicEngine } from '../LogicEngine/LogicEngine';
import { AuditLogType } from './AuditLogTypes';
import { textChangeRangeIsUnchanged } from 'typescript';

export class AuditLog
{
	log: Partial<AuditLogType> = {};

	constructor(participant_id: string, eventText: string)
	{
		this.log.participant_id = participant_id;
		this.log.event_dt = new Date();
		this.log.event_dt_local = new Date().toISOString();
		this.log.reported_dt = new Date();
		this.log.reported_by = LogicEngine.currentUser;
		this.log.reported_device = LogicEngine.currentDeviceId;
		this.log.reported_ip = LogicEngine.currentIpAddress;
		this.log.event_text = eventText;
		this.log.event_type = 99;
		this.log.reference_id = '';
		this.log.timezone_offset = new Date().getTimezoneOffset();

		if (LogicEngine.currentSiteId != "")
			this.log.audit_site_id = LogicEngine.currentSiteId;
	}

	/** Submit the audit record to the server */
	async save(): Promise<void>
	{
		if (!this.log.participant_id || this.log.participant_id === "")
			this.log.participant_id = LogicEngine.currentParticipantID;

		if (!this.log.participant_id || this.log.participant_id === "")
			this.log.participant_id = "none";

		const record = new DataRecord('Audit', this.log);

		// Append line number
		if (!this.log.event_text)
			this.log.event_text = "";

		if (LogicEngine.currentLineNumber > 0)
			this.log.event_text += " l:" + LogicEngine.currentLineNumber;

		record.validateId();
		await record.saveIfNeeded(true);
	}

	/** Set the event type. Should be one of the static values defined at the bottom
	 * of this file but may be different for some specific use cases with trial
	 * configurations.
	 */
	setEventType(evType: number | string)
	{
		if (evType === undefined) throw 'Attempt to set AuditLog Event Type to undefined';
		this.log.event_type = evType;
	}

	/** Set a reference to something, may be different depening on use case and audit type */
	setReference(evReference: string)
	{
		this.log.reference_id = evReference;
	}

	/** Set the page name that we are currently looking at
	 * if this is generated from an event on page.
	 */
	setLinkedRoute(routeName: string)
	{
		/* Todo: Convert a route to an array so we can
		see if there is an ID passed */
		this.log.linked_route = routeName;
	}

	/** When changing a table, reference it */
	setTableName(tableName: string, tableId: string, tableField?: string)
	{
		this.log.table_name = tableName;
		this.log.table_field = tableField;
		this.log.reference_id = tableId;
	}

	/* Set Old and New values for audit and change requests
	 ** These should be Formatted values based on a data formatted for the field
	 */
	setChangeValues(oldValue: string, newValue: string)
	{
		this.log.old_value = oldValue;
		this.log.new_value = newValue;
	}

	/** Set specific reason text */
	setReasonText(newReason: string)
	{
		this.log.reason_text = newReason;
	}

	/** Set the system event flag for something generated as part of
	 * a system process or automated system action.
	 */
	setSystemEvent()
	{
		this.log.is_system_event = true;
	}
	/**
	 * Set Reference Task ID
	 * @param task_id A task ID
	 */
	setReferenceTaskId(task_id: string)
	{
		this.log.reference_task_id = task_id;
	}
}

export namespace AuditLog
{
	export class EventTypes
	{
		static StatusChanged: string = '0';
		static ParticipantNotes: string = '1';
		static RecordLock: string = '95';
		static PageLoad: string = '96';
		static FieldChange: string = '97';
		static DatabaseAudit: string = '98';
		static SystemEvent: string = '99';
	}
}
